import { PaddingType } from 'common/types/styleTypes'
import React from 'react'
import { FaqUi } from './ui/faq-ui'

interface CommonFaqProps {
  children: React.ReactElement[]
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  htmlAttrId: string
  spaceBetweenItems: number
}

export const CommonFaq = ({
  padding,
  mobilePadding,
  htmlAttrId,
  children,
  spaceBetweenItems,
}: CommonFaqProps) => {
  return (
    <FaqUi
      padding={padding}
      mobilePadding={mobilePadding}
      id={htmlAttrId}
      spaceBetweenItems={spaceBetweenItems}
    >
      {children}
    </FaqUi>
  )
}
